module.exports = __webpack_public_path__ + "img/fastlo.e7b2285b.png";